import{purry as e}from"./purry-DH9cw9sy.js";function t(...t){return e(Object.values,t)}export{t as values};
//# sourceMappingURL=values-Dh-ZSz_h.js.map